export default {
  title: 'Articoli esauriti',
  sections: {
    settings: 'Impostazioni',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset:
          'Gli articoli esauriti vengono contrassegnati automaticamente come disponibili alla fine della giornata.',
        manual_reset:
          'Il personale deve contrassegnare nuovamente gli articoli come disponibili dopo averli indicati come esauriti.',
      },
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche fallito',
    changes_got_saved: 'Modifiche salvate',
  },
};
